import { Component, OnInit, OnDestroy  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { OvertimeService } from '../../services/overtime.service';
import { EmployeeService } from '../../services/employee.service';
import { LogService } from '../../services/log.service';
import { ShipService } from '../../services/ship.service';
import { ActivityService } from '../../services/activity.service';
import { AuthService } from '../../services/auth.service';

import { Utils } from '../../util';

@Component({
    selector: 'app-update-overtime',
    templateUrl: './update-overtime.component.html',
    styleUrls: ['./update-overtime.component.css', '../../app.component.css']
})

export class UpdateOvertimeComponent implements OnInit, OnDestroy {

    overtimeForm: FormGroup;
    overtime: any = [];

    authorizes = {};
    authorizeInit: any;
    authorizeText = '';

    employees = {};
    employeeInit: any;
    employeeText = '';

    pickadateParams = Utils.pickadateParams();

    ships = {};
    shipInit: any;
    shipText = '';

    activities = {};
    activityInit: any;
    activityText = '';

    id: string;

    workDate: any;
    hours = 0;

    geSubs: any;
    gsSubs: any;
    gaSubs: any;
    goSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private overtimeService: OvertimeService,
                private employeeService: EmployeeService,
                private logService: LogService,
                private shipService: ShipService,
                private activityService: ActivityService,
                private authService: AuthService) {
        this.loadAuthorizesAndEmployees();
        this.loadShipsAndActivities();

        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.goSubs = this.overtimeService.getOvertime(this.id).subscribe(overtimeObj => {
                this.goSubs.unsubscribe();

                this.overtime = overtimeObj;

                this.workDate = Utils.convertDatefromStringtoISOString(this.overtime.workDate);
                this.hours = this.overtime.hours;
                this.authorizeText = this.overtime.authorizeName;
                this.employeeText = this.overtime.employeeName;
                this.shipText = this.overtime.shipName;
                this.activityText = this.overtime.activityName;
            });

            
        });
    }

    ngOnInit() {
        this.overtimeForm = this.formBuilder.group({
            authorize: ['', Validators.required],
            employee: ['', Validators.required],
            workDate: ['', Validators.required],
            hours: ['', Validators.required],
            activity: ['', Validators.required],
            ship: ['', Validators.required]
        });
    }

    ngOnDestroy() {
        this.geSubs.unsubscribe();
        this.gsSubs.unsubscribe();
        this.gaSubs.unsubscribe();
    }

    loadAuthorizesAndEmployees() {
        this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployees => {
            const data = {};

            for (const idx in tempEmployees) {
                let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
                data[employeeDisplayValue] = null;

                this.authorizes[employeeDisplayValue] = tempEmployees[idx].id$;
                this.employees[employeeDisplayValue] = tempEmployees[idx].id$;
            }

            this.authorizeInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.authorizes[val]);
                }
            };

            this.employeeInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.employees[val]);
                }
            };
        });
    }

    loadShipsAndActivities() {
        this.gsSubs = this.shipService.getShips().subscribe(tempShips => {
            const dataShips = {};

            for (const idx in tempShips) {
                dataShips[tempShips[idx].name] = null;

                this.ships[tempShips[idx].name] = tempShips[idx].id;
            }

            this.shipInit = {
                'data': dataShips,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.ships[val]);
                }
            };
        });

        this.gaSubs = this.activityService.getActivities().subscribe(tempActivities => {
            const dataActivities = {};

            for (const idx in tempActivities) {
                dataActivities[tempActivities[idx].name] = null;

                this.activities[tempActivities[idx].name] = tempActivities[idx].id;
            }

            this.activityInit = {
                'data': dataActivities,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.activities[val]);
                }
            };
        });
    }

    onBlurAuthorize() {
        if (this.authorizes[this.authorizeText] === undefined) {
            this.authorizeText = '';
        }
    }

    onBlurEmployee() {
        if (this.employees[this.employeeText] === undefined) {
            this.employeeText = '';
        }
    }

    onBlurShip() {
        if (this.ships[this.shipText] === undefined) {
            this.shipText = '';
        }
    }

    onBlurActivity() {
        if (this.activities[this.activityText] === undefined) {
            this.activityText = '';
        }
    }

    onSubmitOvertime() {
        this.overtime = this.saveOvertime();

        this.overtimeService.putOvertime(this.overtime, this.id).then(res => {
            this.router.navigate(['/overtimes']);
        });
    }

    saveOvertime() {
        const workDate = Utils.convertDatefromISOStringtoObject(this.overtimeForm.get('workDate').value);

        const userSession = this.authService.currentUser;

        const overtimeJson = {
            authorizeId: this.authorizes[this.overtimeForm.get('authorize').value],
            authorizeName: this.overtimeForm.get('authorize').value,
            employeeId: this.employees[this.overtimeForm.get('employee').value],
            employeeName: this.overtimeForm.get('employee').value,
            hours: this.overtimeForm.get('hours').value,
            updatedAt: new Date(),
            workDate: workDate,
            activityId: this.activities[this.overtimeForm.get('activity').value],
            activityName: this.overtimeForm.get('activity').value,
            shipId: this.ships[this.overtimeForm.get('ship').value],
            shipName: this.overtimeForm.get('ship').value
        };

        return overtimeJson;
    }

}
